import React, { createContext, useReducer } from "react";
import Layout from "../layout";
import Slider from "./Slider";
import ProductCategory from "./ProductCategory";
import { homeState, homeReducer } from "./HomeContext";
import SingleProduct from "./SingleProduct";
import GenderOptions from "./GenderOptions";
import ProductCard from "./ProductCard";
import Prazo from "./Prazo";
import FeaturesSection from "./FeaturesSection";
import WhatsAppButton from "./WhatsAppButton";

// Criação do Contexto
export const HomeContext = createContext();

const SectionWrapper = ({ title, children, bg = "white" }) => (
  <section className={`py-6 ${bg === "gray-50" ? "bg-gray-50" : "bg-white"}`}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {title && (
        <h2 className="text-xl md:text-2xl font-semibold text-center text-gray-800 mb-4">
          {title}
        </h2>
      )}
      <div className="mt-2">{children}</div>
    </div>
  </section>
);

const HomeComponent = () => (
  <div className="space-y-4">
    <Slider />

    <SectionWrapper>
      <ProductCategory />
    </SectionWrapper>

    <SectionWrapper>
      <SingleProduct />
    </SectionWrapper>

    <SectionWrapper title="FlitzStoreBR - Atacado" bg="gray-50">
      <GenderOptions />
    </SectionWrapper>

    <SectionWrapper title="Produtos em Destaque">
      <ProductCard />
    </SectionWrapper>

    <SectionWrapper title="Informações de Frete e Prazo">
      <Prazo />
    </SectionWrapper>

    <FeaturesSection />

    <WhatsAppButton phoneNumber="559591273913?text=Olá,%20estou%20navegando%20pelo%20site%20da%20FlitzStoreBR%20e%20gostaria%20de%20tirar%20uma%20dúvida%20sobre%20os%20produtos.%20Pode%20me%20ajudar?" />
  </div>
);

const Home = () => {
  const [data, dispatch] = useReducer(homeReducer, homeState);

  return (
    <HomeContext.Provider value={{ data, dispatch }}>
      <Layout>
        <HomeComponent />
      </Layout>
    </HomeContext.Provider>
  );
};

export default Home;